import { div, minus } from "src/shared/helpers/calculator"

export function getPorcentajeGanancia(precio: number, costo: number){
    const ganancia = minus(precio, costo)

    return Number(Number(div(ganancia,  precio) * 100).toFixed(2))
}